import script from "./ordemServicoFilter.vue?vue&type=script&setup=true&lang=js"
export * from "./ordemServicoFilter.vue?vue&type=script&setup=true&lang=js"

import "./ordemServicoFilter.vue?vue&type=style&index=0&id=6d9b946a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d9b946a"]])

export default __exports__